import React, {Component} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,

  Box,
  Grid,
  Button,
  Backdrop,
  Typography,
  CircularProgress
} from "@mui/material";
import {
  makeStyles,
  withStyles,
} from "@mui/styles";
import {
  FileUploader,
  DialogConfirmation
} from "../../../../../components";
import {
  Notification,
  notificationTypes
} from "../../../../../common/Notification";
import agent from "../../../../../agent/agent";

class DialogPicturesNew extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pictures: [],
      uploadImages: [],
      orderId: null,
      isOpen: false,
      isBackdrop: false,
    };
    this.refDialogConfirmation = React.createRef();
  }

  open = ({ pictures, orderId }) => {
    this.setState({
      pictures: pictures || [],
      orderId: orderId,
      isOpen: true,
    });
  }
  close = () => {
    this.setState({
      pictures: [],
      orderId: null,
      isOpen: false,
    })
  }

  removeUploadImages = (index) => {
    let uploadImages = [...this.state.uploadImages];
    uploadImages.splice(index, 1);
    this.setState({ uploadImages });
  }
  changeUploadImages = ({ target }) => {
    const value = [...(target?.value || [])];
    this.setState({
      uploadImages: [
        ...this.state.uploadImages,
        ...value
      ]
    })
  }

  sendImageToServer = async (item, index) => {
    await this.setState({ isBackdrop: true });
    const formData = new FormData();
    formData.append("file", item.file);
    const res = await agent.post(`/orders/mechanic/${ this.state.orderId }/pictures`, formData)
      .then((res) => true)
      .catch((err) => {
        return {error: err?.response || true}
      });
    if (res?.error) {
      await this.setState({ isBackdrop: false });
      Notification({
        type: notificationTypes.error,
        message: "Ошибка загрузки файла, повторите попытку"
      })
      return
    }

    let pictures = [...(this.state.pictures)];
    pictures.push({
      updated_at: item?.file?.lastModified,
      url: URL.createObjectURL(item.file),
      type: (item?.file?.type || item?.file?.mimetype || ""),
    })
    let uploadImages = [...(this.state.uploadImages)];
    uploadImages.splice(index, 1);

    await this.setState({
      pictures,
      uploadImages,
      isBackdrop: false
    });
    Notification({
      type: notificationTypes.success,
      message: "Файл успешно загружен"
    })
    await this.props.onUpdateOrder();
  }
  removeImageFromServer = async (item, index, isConfirm) => {
    if (!isConfirm) {
      this.refDialogConfirmation.current.onOpen({
        message: "Вы действительно хотите удалить фото?",
        acceptButtonTitle: "Да, удалить",
        acceptButtonAction: this.removeImageFromServer.bind(this, item, index, true)
      })
      return
    }
    this.setState({ isBackdrop: true })
    const { orderId } = this.state;
    const isSuccess = await agent.delete(`/orders/mechanic/${ orderId }/pictures/${ item.id }`)
      .then(() => true)
      .catch(() => false);
    if (!isSuccess) {
      this.setState({ isBackdrop: false })
      Notification({
        type: notificationTypes.error,
        message: "Ошибка удаление файла, повторите попытку позднее"
      })
      return
    }
    let pictures = [...(this.state.pictures)];
    pictures.splice(index, 1);
    this.setState({ isBackdrop: false, pictures });
    Notification({
      type: notificationTypes.success,
      message: "Файл успешно удален"
    })
    await this.props.onUpdateOrder();
  }

  render () {
    const {
      isOpen,
      orderId,
      pictures,
      isBackdrop,
      uploadImages
    } = this.state;
    const {
      classes
    } = this.props;
    const isEmpty = Boolean(pictures.length <= 0 && uploadImages.length <= 0);

    return (
      <>
        <Dialog
          open={isOpen}
          fullWidth={true}
          onClose={this.close}
          classes={{root: classes.root}}
        >
          <DialogTitle className={classes.header}>
            <Typography variant="h3">Мультимедиа</Typography>
          </DialogTitle>
          <DialogContent>
            <Box className={classes.contentScroll}>
              {Boolean(isEmpty) && (<Typography>У заказа нет изображений и видео</Typography>)}
              {pictures.map((item, index) => (
                <ItemPicture
                  key={`ItemPicture-${ item?.updated_at }`}
                  item={item}
                  hideAction={!orderId}
                  onRemove={this.removeImageFromServer.bind(this, item, index, false)}
                />
              ))}
              {uploadImages.map((item, index) => (
                <ItemUpload
                  key={`ItemUpload-${ item?.file?.lastModified }`}
                  item={item}
                  onRemove={this.removeUploadImages.bind(this, index)}
                  onSend={this.sendImageToServer.bind(this, item, index)}
                />
              ))}
            </Box>

            {Boolean(orderId) && (
              <>
                <PhotoImageMini
                  images={uploadImages}
                  onChange={this.changeUploadImages}
                />
                <Typography className={classes.caption}>Для завершения процесса загрузки проверьте выбранный файл и обязательно нажмите кнопку «Загрузить».</Typography>
              </>
            )}
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={this.close}
                >Закрыть</Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <DialogConfirmation ref={this.refDialogConfirmation}/>
        <Backdrop open={isBackdrop}>
          <CircularProgress/>
        </Backdrop>
      </>
    )
  }
}
const ItemPicture = ({ item, hideAction, onRemove }) => {
  const classes = useStyles();
  const isVideo = Boolean((item?.type || item?.mimetype || "").includes("video"));

  return (
    <Box className={classes.itemPicture}>
      <div className="content">
        {!isVideo && (<img src={item?.url}/>)}
        {isVideo && (<video muted controls playsinline preload="auto">
          <source src={item?.url}/>
        </video>)}
      </div>

      {!Boolean(hideAction) && (
        <div className="action">
          <Button fullWidth variant="outlined" onClick={onRemove}>
            Удалить
          </Button>
        </div>
      )}
    </Box>
  )
}
const ItemUpload = ({ item, onSend, onRemove }) => {
  const { file } = item;
  const classes = useStyles();
  const isVideo = Boolean((file?.type || file?.mimetype || "").includes("video"));
  const [imagePath, setImagePath] = React.useState(() => {
    return URL.createObjectURL(file);
  });

  return (
    <Box className={classes.itemPicture}>
      <div className="content">
        {!isVideo && (<img src={imagePath}/>)}
        {isVideo && (<video muted controls playsinline preload="auto"><source src={imagePath}/></video>)}
      </div>
      <div className="action">
        <Button fullWidth variant="outlined" onClick={onRemove}>
          Удалить
        </Button>
        <Button fullWidth variant="contained" onClick={onSend}>
          Загрузить
        </Button>
      </div>
    </Box>
  )
}
const PhotoImageMini = (props) => {
  const {
    images,
    onChange,
    onDelete,
    disabledCreate
  } = props;
  const classes = useStyles();

  const handleChangeForm = (event) => {
    onChange(event);
  }

  return (
    <div className={classes.photoImageMini}>
      <FileUploader
        value={images}
        multiple={true}
        name="files"
        hideSelected={true}
        placeholder="Выберите файлы"
        disabledCreate={disabledCreate}
        accept={{
          "image/gif": [".gif"],
          "image/jpeg": [".jpeg", ".jpg"],
          "image/png": [".png"],
          "image/webp": [".webp"],

          "video/mpeg": [".mpeg"],
          "video/mp4": [".mp4", ".mkv"],
          "video/mkv": [".mp4", ".mkv"],
          "video/ogg": [".ogv"],
          "video/webm": [".webm"],
          "video/x-msvideo": [".avi"],
          "video/3gpp": [".3gp"],
          "video/3gpp2": [".3g2"],
          "video/quicktime": [".quicktime"],

          'application/pdf': ['.pdf'],
          'application/msword': ['.doc'],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
        }}
        onChange={handleChangeForm}
        onDeleteWorkFile={onDelete}
      />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  photoImageMini: {
    "& .root-dropzone": {
      height: 40,
      borderRadius: 8,
      background: "#F266221A",
      border: "1px solid #F2662233",

      "& .--message": {
        color: "#F26622",
        fontSize: 14,
        lineHeight: 1.2,
        fontWeight: '500',
      }
    }
  },

  itemPicture: {
    padding: "4px",
    borderRadius: 8,
    overflow: "hidden",
    position: "relative",
    boxSizing: "border-box",
    border: "1px solid #F2662233",

    "& img": {
      maxWidth: "100%",
    },
    "& video": {
      width: "100%",
      maxWidth: "100%",
      background: "#F266221A",
    },
    "& .content": {
      borderRadius: 6,
      overflow: "hidden",
      position: "relative",
    },
    "& .action": {
      display: "flex",
      flexWrap: "nowrap",
      gap: "6px",
      marginTop: "6px",
    }
  }
}))

const styles = {
  root: {
    "@media(max-width: 1023px)": {
      "& .MuiPaper-root": {
        margin: "0",
        width: "100%",
        maxWidth: "100%",
      },
      "& .MuiDialog-scrollPaper": {
        alignItems: "flex-end",
        justifyContent: "initial",
      }
    }
  },
  header: {
    padding: "12px 8px!important",
    background: "#FCE0D3",
    "& .MuiTypography-h3": {
      color: "#F26622",
      textAlign: "left",
      alignItems: "flex-start"
    }
  },
  contentScroll: {
    display: "block",
    height: "65dvh",
    padding: "12px 0",
    overflow: "auto",
    boxSizing: "border-box",
    "& > *": {
      marginTop: "12px",
      "&:first-child": {
        marginTop: "0",
      }
    }
  },
  actions: {
    background: "#FCE0D3",

    "& .MuiButton-root": {
      height: 40,
      borderRadius: 8,
      fontSize: 15
    },
    "& .MuiButton-outlined": {
      background: "transparent",
      borderColor: "#F26622",
      color: "#F26622",
    }
  },
  caption: {
    marginTop: "4px",
    fontSize: 12,
    lineHeight: 1.2,
    color: "#F26622",
    letterSpacing: "-0.02em",
  },
};
DialogPicturesNew = withStyles(styles)(DialogPicturesNew);

export default DialogPicturesNew;
